import maplibreGL from "@maplibre/maplibre-gl-leaflet/leaflet-maplibre-gl.js";
import { createElementObject, createLayerComponent, withPane } from "@react-leaflet/core";
import "maplibre-gl/dist/maplibre-gl.css";

type OpenFreeMapLayerProps = {
  attribution?: string;
  styleUrl: string;
};

export const OPEN_FREE_MAP_ATTRIBUTION =
  '<a href="https://openfreemap.org">OpenFreeMap</a> <a href="https://www.openmaptiles.org">&copy; OpenMapTiles</a> <a href="https://www.openstreetmap.org/copyright">&copy; OpenStreetMap</a>';

export const OpenFreeMapLayer = createLayerComponent(
  ({ attribution = OPEN_FREE_MAP_ATTRIBUTION, styleUrl, ...options }: OpenFreeMapLayerProps, context) => {
    const layer = maplibreGL({
      attribution,
      maxZoom: 22,
      style: styleUrl,
      ...withPane(options, context),
    } as Parameters<typeof maplibreGL>[0]);
    return createElementObject(layer, context);
  },
  (layer, props, prevProps) => {
    if (props.styleUrl !== prevProps.styleUrl) {
      layer.getMaplibreMap().setStyle(props.styleUrl);
    }
  }
);
